'use strict';

export const blockSite = (() => {
  let _line;
  let lineWidth = 0;

  const eventListeners = () => {
    window.addEventListener("resize", function() {
      addSpans();
    });
  };

  const addSpans = () => {
    if (!_line) return;
    const wW = window.innerWidth;
    const text = _line.getAttribute('data-text');
    _line.innerHTML = text;
    setTimeout(()=>{
      lineWidth = Math.ceil(_line.clientWidth + wW*0.11);
      _line.innerHTML = '';
      const cnt = Math.ceil(wW * 2 / lineWidth);
      let html = '';
      for (let i=0; i < cnt; i++) {
        html += `<span style="margin-right: ${wW*0.11}px">${text}</span>`;
      }
      _line.innerHTML = html;
    },0);
  };

  let left = 0;
  const setML = () => {
    if (!_line) return;
    _line.style['margin-left'] = `${left}px`;
  };
  const animLine = function () {
    requestAnimationFrame(animLine);

    left = (left <= -lineWidth) ? 0 : left-2;
    setML();
  };

  const init = () => {
    _line = document.querySelector('.projects_single__site__line');
    if (!_line || _line.getAttribute('data-text') === '') {
      return false;
    }
    addSpans();
    setTimeout(()=>{
      animLine();
    }, 50);
    eventListeners();
  };

  return {
    init
  }
})();
